module.exports = __webpack_public_path__ + "static/pomoc-drogowa-033b16c2aa005d0e2009b7181ec8043e.jpeg";